import { cn } from '@/lib/utils';
import { textVariants } from '@/src/components/Text/Text';
import { formatNumber } from '@/src/utils';
import { sellPaymentType } from '../DirectTrade';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@/src/components/shad/alert';
import { ArrowRight } from 'lucide-react';

interface Props {
  previewInfo: TradeDirectPreviewInfo | undefined;
  tradeType: string;
  coin: CoinRate | undefined;
  paymentMethods: ComponentsPaymentMethod[] | undefined;
  selectedPayment: number | undefined;
  sellPayments: sellPaymentType[] | undefined;
}

const Preview = ({
  previewInfo,
  tradeType,
  coin,
  paymentMethods,
  selectedPayment,
  sellPayments,
}: Props) => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.buysell.preview.${key}`);
  const transInstructions = (key: string) =>
    t(`app.components.tradeInstructions.${key}`);
  const pm = paymentMethods?.find((item) => item?.id === selectedPayment);

  return (
    <div>
      {' '}
      {previewInfo && (
        <div className=' bg-gray-100 dark:bg-grey-600 rounded-md grid p-4'>
          <div className='grid '>
            <span className={textVariants({ variant: 'desc' })}>
              {tradeType === 'buy' ? trans('type.buy') : trans('type.sell')}
            </span>
            <span
              className={textVariants({
                size: 'xxxl',
                font: 'bold',
                case: 'uppercase',
              })}
            >
              {previewInfo?.amount_crypto} {coin?.coin__ticker}
            </span>
          </div>
          {tradeType === 'buy' && (
            <Alert className='bg-[#DE8A2533] border-l-2 border-l-[#DE8A25]'>
              <AlertDescription>
                <ul className=' text-xs text-gray-600 dark:text-white space-y-2 mt-2'>
                  <div className='flex items-center  gap-2'>
                    <ArrowRight className='h-4 w-4 ' />
                    <span className='flex-1'>{transInstructions('1')}</span>
                  </div>
                  <div className='flex items-center  gap-2'>
                    <ArrowRight className='h-4 w-4 ' />
                    <span className='flex-1'>{transInstructions('2')}</span>
                  </div>
                  <div className='flex items-center  gap-2'>
                    <ArrowRight className='h-4 w-4 ' />
                    <span className='flex-1'>{transInstructions('3')}</span>
                  </div>
                  <div className='flex items-center  gap-2'>
                    <ArrowRight className='h-4 w-4 ' />
                    <span className='flex-1'>{transInstructions('4')}</span>
                  </div>
                </ul>
              </AlertDescription>
            </Alert>
          )}
          <div className='grid gap-5 mt-5'>
            <div className='flex items-center justify-between '>
              <span className={textVariants({ variant: 'desc' })}>
                <span className='uppercase'>{coin?.coin__ticker}</span>{' '}
                {trans('currentPrice')}
              </span>
              <span className={textVariants({ font: 'semibold' })}>
                USD {formatNumber(previewInfo?.coin_price)}
              </span>
            </div>

            <div className='flex items-center justify-between '>
              <span className={textVariants({ variant: 'desc' })}>
                {trans('fee')}
              </span>
              <span className={textVariants({ font: 'semibold' })}>
                USD {formatNumber(previewInfo?.fee)}
              </span>
            </div>
            <div className='flex items-center justify-between '>
              <span className={textVariants({ variant: 'desc' })}>
                {tradeType === 'buy'
                  ? trans('amount.receive')
                  : trans('amount.deducted')}
              </span>
              <div>
                <span className={textVariants({ font: 'semibold' })}>
                  USD {formatNumber(previewInfo?.amount_fiat_usd)}
                </span>
                {/* {"/ "}
                        <span className={textVariants({ size: 'sm' })}>{previewInfo?.amount_crypto}</span> */}
              </div>
            </div>
            {tradeType === 'buy' ? (
              <div className='flex items-center justify-between '>
                <span className={textVariants({ variant: 'desc' })}>
                  {trans('paymentMethod')}
                </span>
                <div>
                  <span
                    className={cn(
                      textVariants({ font: 'semibold' }),
                      'flex items-center gap-2'
                    )}
                  >
                    <img
                      src={pm?.service__image}
                      className='h-5 w-5 rounded-full'
                      alt={pm?.service__name}
                    />{' '}
                    {pm?.service__name}
                  </span>
                </div>
              </div>
            ) : (
              <div className='flex items-center justify-between '>
                <span className={textVariants({ variant: 'desc' })}>
                  {trans('paymentMethod')}
                </span>
                <div className='grid gap-1'>
                  {sellPayments?.map((item) => (
                    <span
                      className={cn(
                        textVariants({ font: 'semibold' }),
                        'flex items-center gap-2'
                      )}
                      key={item.id}
                    >
                      <img
                        src={item?.image}
                        className='h-5 w-5 rounded-full'
                        alt={item?.service_name}
                      />{' '}
                      <span>{item?.service_name}</span>
                    </span>
                  ))}
                </div>
              </div>
            )}
            <div className='flex items-center justify-between '>
              <span className={textVariants({ variant: 'desc', font: 'bold' })}>
                {tradeType === 'buy'
                  ? trans('total.pay')
                  : trans('total.receive')}
              </span>
              <span
                className={cn(
                  'dark:text-yellow-600 text-yellow-500 text-xl font-bold'
                  // textVariants({ font: "bold", size: "xl" })
                )}
              >
                {previewInfo?.currency_symbol} {''}
                {formatNumber(previewInfo?.amount_fiat_local)}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Preview;
